'use client';

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { useTranslations } from '@/hooks/useTranslations';
import { CreateInvoiceForm } from './create-invoice-form';
import { useInvoiceContext } from '@/contexts/invoice-context';

export const CreateInvoicePopup = () => {
  const { state: invoice, dispatch } = useInvoiceContext();

  const t = useTranslations('CreateInvoicePopup');

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      dispatch({ type: 'CLOSE_CREATE_INVOICE_POPUP' });
    }
  };

  return (
    <Sheet
      open={invoice.isCreateInvoicePopupOpen}
      onOpenChange={handleOpenChange}
    >
      <SheetContent className="bg-white dark:bg-black">
        <SheetHeader>
          <SheetTitle className="text-left">{t('title')}</SheetTitle>
          <SheetDescription>{t('description')}</SheetDescription>
        </SheetHeader>

        <div className="grid gap-4 p-4">
          <CreateInvoiceForm />
        </div>
      </SheetContent>
    </Sheet>
  );
};
